import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators} from 'redux';
import {
    Modal, Header, Table
} from 'semantic-ui-react';
import FileUploadButton from './FileUploadButton';

class ExcelUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    render() {
        const {
            displayModal, onCloseModalClick, onUploaded, sprAlert
        } = this.props;

        return (
            <Modal
                closeOnDimmerClick={false}
                closeIcon
                onClose={() => {onCloseModalClick()}}
                closeOnEscape={true} open={displayModal}>
                <Header icon='file excel outline' content={"Upload SPR Product List"} />

                <Modal.Content>
                    {sprAlert ? <div style={{marginBottom: '20px'}}>
                        <Header as='h4'>
                            Please replace your column headers to the following before import
                            <Header.Subheader>You can copy the following and "paste value only" to your excel sheet header.</Header.Subheader>
                        </Header>
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.Cell>SKU</Table.Cell>
                                    <Table.Cell>DC1</Table.Cell>
                                    <Table.Cell>DC2</Table.Cell>
                                    <Table.Cell>Description</Table.Cell>
                                    <Table.Cell>UOM</Table.Cell>
                                    <Table.Cell>UPC</Table.Cell>
                                    <Table.Cell>Catalog</Table.Cell>
                                    <Table.Cell>Cost</Table.Cell>
                                    <Table.Cell>Sell</Table.Cell>
                                    <Table.Cell>MSRP</Table.Cell>
                                    <Table.Cell>MenuTag</Table.Cell>
                                    <Table.Cell>SecondTag</Table.Cell>
                                    <Table.Cell>ThirdTag</Table.Cell>
                                    <Table.Cell>HomeTag</Table.Cell>
                                </Table.Row>
                            </Table.Header>
                        </Table>
                    </div> : null}
                    <FileUploadButton 
                        name="Upload Excel"
                        jwt={this.props.jwt}
                        onSuccess={(data) => {onUploaded(data)}}
                    />
                </Modal.Content>
            </Modal>
        )
    }
}

ExcelUpload.propTypes = {
    displayModal: PropTypes.bool.isRequired,
    onCloseModalClick: PropTypes.func.isRequired,
    onUploaded: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ExcelUpload);


// WEBPACK FOOTER //
// ./src/components/ecommerce/ExcelUpload.js